import React from 'react';

import {connect} from 'react-redux';
import {compose} from 'redux';
import './styles.scss';

interface SearchIconProps {
  globalStyles: any;
  className: any;
}

function SearchIcon({globalStyles, className}: SearchIconProps) {
  return (
    <span className={className}>
      <svg
        width="17px"
        height="17px"
        viewBox="0 0 17 17"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink">
        <title></title>
        <defs>
          <path
            d="M6.328125,0 C9.82305193,0 12.65625,2.83319807 12.65625,6.328125 C12.65625,7.52710534 12.3228045,8.64820531 11.7435885,9.60374995 L15.7875682,13.64824 C16.3367429,14.1974148 16.0554929,14.8065531 15.5063182,15.3557279 C14.9571434,15.9049026 14.3480051,16.1861526 13.7988303,15.6369779 L13.7988303,15.6369779 L9.78908647,11.6268123 C8.79451806,12.2777617 7.60552187,12.65625 6.328125,12.65625 C2.83319807,12.65625 0,9.82305193 0,6.328125 C0,2.83319807 2.83319807,0 6.328125,0 Z M6.328125,2.8125 C4.38649893,2.8125 2.8125,4.38649893 2.8125,6.328125 C2.8125,8.26975107 4.38649893,9.84375 6.328125,9.84375 C8.26975107,9.84375 9.84375,8.26975107 9.84375,6.328125 C9.84375,4.38649893 8.26975107,2.8125 6.328125,2.8125 Z"
            id="path-1"></path>
        </defs>
        <g
          id="08---Consultas-Online"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd">
          <g id="MY-D-08-02-01" transform="translate(-733.000000, -577.000000)">
            <g id="Group-3" transform="translate(431.000000, 564.000000)">
              <g
                id="ELEMENTS/ICONS/Calendar/Standard"
                transform="translate(302.843750, 13.843750)">
                <mask id="mask-2" fill="white">
                  <use xlinkHref="#path-1"></use>
                </mask>
                <use
                  id="Color"
                  fill={globalStyles.primaryColor}
                  fill-rule="nonzero"
                  xlinkHref="#path-1"></use>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
}

const mapStateToProps = ({globalStyles}: any) => ({
  globalStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(SearchIcon));
